<template>
  <div class="stepper">
    <transition name="slide-fade">
      <div v-if="advance.secondStepActive === 1">
        <div class="mb-5">
          <div class="row justify-content-center align-items-center">
            <div class="col img-result">
              <div class="mb-5">
                <div class="row align-items-end no-gutters">
                  <div class="col">
                    <img
                      class="img-fluid img-main"
                      src="../assets/images/result.png"
                    />
                    <!-- progress -->
                    <div class="text-center">
                      <div id="countdown">
                        <div class="progress__wrap">
                          <div class="progress__bar">
                            <div
                              class="progress__bar--status"
                              v-bind:class="
                                result.diffPercent
                                  | getColorProgressBarByPercent
                              "
                              v-bind:style="{ width: result.diffPercent + '%' }"
                            ></div>

                            <img
                              v-if="result.diffPercent >= 80"
                              class="person"
                              src="../assets/images/high.png"
                              v-bind:style="{
                                left: `calc(${result.diffPercent}% - 30px)`,
                              }"
                            />

                            <img
                              v-if="
                                result.diffPercent >= 50 &&
                                  result.diffPercent < 80
                              "
                              class="person"
                              src="../assets/images/medium.png"
                              v-bind:style="{
                                left: `calc(${result.diffPercent}% - 30px)`,
                              }"
                            />

                            <img
                              v-if="
                                result.diffPercent >= 0 &&
                                  result.diffPercent < 50
                              "
                              class="person"
                              src="../assets/images/low.png"
                              v-bind:style="{
                                left: `calc(${result.diffPercent}% - 30px)`,
                              }"
                            />

                            <div
                              style=" width: 70px;
                                                          z-index: 1;
                                                      position: absolute;
                                                      top : 45px;"
                              class="person txt-navy"
                              v-bind:style="{
                                left: `calc(${result.diffPercent}% - 45px)`,
                              }"
                            >
                              <small>
                                {{
                                  result.diffPercent | setNumberFormat(2)
                                }}%</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end progress -->
                  </div>
                  <div class="col-auto">
                    <img
                      class="img-fluid img-flag"
                      src="../assets/images/flag.png"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group text-center">
                <div
                  class="md-title"
                  v-bind:class="result.diffPercent | getColorByPercent"
                >
                  {{ result.diffPercent | getWordingByPercent }}
                </div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label
                    >คุณอายุ
                    <span class="txt-primary"> {{ params.currentAge }} </span>ปี
                    ต้องการเกษียณอายุ
                    <span class="txt-primary"> {{ params.retiredAge }} </span>ปี
                  </label>
                </div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label>ต้องการมีเงินใช้หลังเกษียณ (ต่อเดือน)</label>
                </div>
                <div class="col-12 col-sm-auto">
                  <span class="txt-primary">
                    {{ result.spendPerMonth | setNumberFormat }}
                  </span>
                  บาท
                </div>
              </div>

              <div class="row mb-5">
                <div class="col">
                  <label>
                    เมื่อรวมค่าใช้จ่ายต่าง ๆ ต้องมีเงินใช้จ่ายหลังเกษียณ
                    <img
                      class="img-fluid icon-info"
                      @click="getInfo('เงินใช้จ่ายหลังเกษียณ')"
                      src="../assets/images/info.png"
                    />
                  </label>
                </div>
                <div class="col-12 col-sm-auto">
                  <span class="txt-primary">
                    {{ result.sumSpend | setNumberFormat }}
                  </span>
                  บาท
                </div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label>คุณมีเงินสะสม ณ วันที่เกษียณอายุ</label>
                </div>
                <div class="col-12 col-sm-auto">
                  <span class="txt-primary">
                    {{ result.sumIncome | setNumberFormat }}
                  </span>
                  บาท
                </div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label>ดังนั้น ต้องเก็บออมเพิ่ม</label>
                </div>
                <div class="col-12 col-sm-auto">
                  <span class="txt-primary">
                    {{ result.diff | setNumberFormat }}</span
                  >
                  บาท
                </div>
              </div>

              <div class="row form-group">
                <div class="col">
                  <label
                    >คุณมีเวลาออมเงิน
                    <span class="txt-primary">
                      {{ result.remainingYear }}
                    </span>
                    ปี ต้องออมเงินเพิ่มเดือนละ</label
                  >
                </div>
                <div class="col-12 col-sm-auto">
                  <span class="txt-primary">
                    {{ result.saveAddMorePerMonth | setNumberFormat }} </span
                  >บาท
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-5">
          <div class="form-group text-center">
            <div class="md-title">
              {{
                result.diffPercent === 100
                  ? "ทดลองปรับแผนอื่นๆ"
                  : "ทดลองปรับแผนเพื่อให้ถึงเป้าหมาย"
              }}
            </div>
          </div>

          <div class="row">
            <div
              class="col-12 col-lg-4"
              v-for="(data, index) of suggestion"
              :key="index"
            >
              <div class="guidePlan">
                <div class="title">{{ data.name }}</div>
                <hr class="line" />

                <div class="row content align-items-center">
                  <div class="col-12">
                    <div
                      @click="changePlan(data.type, plan)"
                      class="button-gray full-width"
                      v-for="(plan, index) of data.plan"
                      :key="index"
                      v-bind:class="{
                        active:
                          plan.value_raw === parseFloat(params[plan.name]),
                      }"
                    >
                      {{ plan.value }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mb-5 row justify-content-center align-items-center txt-gray"
        >
          <div class="col img-result">
            <small>
              * โปรแกรมคำนวณนี้เป็นเพียงการประมาณเท่านั้น เช่น
              ผลตอบแทนจากการลงทุน คุณอาจได้รับมากกว่าหรือน้อยกว่าที่ใช้คำนวณ
              และเงินออมบางส่วนคุณอาจได้รับเป็นรายเดือน
              หรือไม่ได้ทั้งจำนวนตอนเกษียณก็ได้
            </small>
          </div>
        </div>

        <div class="row justify-content-center mb-5">
          <div class="col-auto">
            <div class="button-accent" @click="redirectType('edit')">
              เเก้ไข
            </div>
          </div>

          <div class="col-auto">
            <div class="button-sky" @click="nextSubStep(2)">บันทึก</div>
          </div>
        </div>

        <div class="row justify-content-center ">
          <div class="col-auto">
            <div class="button-yellow" @click="redirectType('new')">ทำใหม่</div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slide-fade">
      <div class="stepper-content" v-if="advance.secondStepActive === 2">
        <div class=" text-center mb-4">
          <div class="title">บันทึกผลการคำนวณ</div>
        </div>

        <div class="mb-3">
          <div class="row">
            <div class="col-12 col-sm-4">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img class="img-fluid icon" src="../assets/images/bell.png" />
                </div>
                <div class="col label no-padding">
                  การแจ้งเตือน
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <select v-model="form.period" class="form-control">
                <option v-bind:value="0"> ไม่รับการเเจ้งเตือน</option>
                <option v-bind:value="1"> 1 เดือน</option>
                <option v-bind:value="3"> 3 เดือน</option>
                <option v-bind:value="6"> 6 เดือน</option>
                <option v-bind:value="12"> 12 เดือน</option>
              </select>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <div class="row">
            <div class="col-12 col-sm-4">
              <div class="row align-items-center form-group">
                <div class="col-auto">
                  <img class="img-fluid icon" src="../assets/images/mail.png" />
                </div>
                <div class="col label no-padding">
                  Email
                </div>
              </div>
            </div>

            <div class="col-12 col-sm form-group input-group-lg">
              <input
                v-model="form.email"
                class="form-control"
                name="email"
                placeholder="โปรดระบุ"
              />
              <error-message :msg="errorMessage.email"></error-message>
              <input class="input-policy" type="checkbox" v-model="checked" />

              <span class="ml-2"> ยอมรับ </span> <a class="txt-primary pointer" @click="getPolicy()">นโยบายคุ้มครองความเป็นส่วนตัว</a>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-auto">
            <button class="button-yellow" :disabled="!checked" @click="save()">
              ถัดไป
            </button>
          </div>
        </div>
      </div>
    </transition>

    <dialog-normal
      :data="dataDialogNormal"
      :show="showDialogNormal"
      :dialog="dialog"
      @close="close"
    ></dialog-normal>

    <dialog-policy
        :data="dataDialogPolicy"
        :show="showDialogPolicy"
        :dialog="dialog"
        @close="close"
    ></dialog-policy>
  </div>
</template>

<script>
import DialogNormal from "./dialogNormal";
import DialogPolicy from "./dialogPolicy";

import { mapState } from "vuex";
import store from "../store";
import { retirementService } from "../services/retirement";
import {
  SET_ADVANCE_SUB_ACTIVE,
  SET_ADVANCE_STEPPER_DATA,
  SEND_EMAIL,
  SET_ALERT,
  SET_ADVANCE_ACTIVE, ACCEPT_POLICY, GET_POLICY,
} from "../store/actions.type";
import * as validate from "validate.js";
import ErrorMessage from "./errorMessage";
import { assetsService } from "../services/assets";
import { scroller } from "vue-scrollto/src/scrollTo";

export default {
  name: "ResultAdvance",
  components: { ErrorMessage, DialogNormal , DialogPolicy},
  computed: mapState({
    advance: (state) => state.advance,
    result: (state) => state.advance.data.result,
    suggestion: (state) => state.advance.data.suggestion,
    form: (state) => state.advance.data.notification,
    params: (state) => state.advance.data.params,
    policy: (state) => state.policy.data,
  }),
  data: () => ({
    active: "first",
    checked: false,
    dialog: {
      header: null,
      message: null,
    },
    showDialogNormal: false,
    dataDialogNormal: {},

    showDialogPolicy: false,
    dataDialogPolicy: {},

    errorMessage: {},
    redirect: false,
  }),
  async created() {
    await store.dispatch(GET_POLICY);
  },
  methods: {
    nextSubStep(nextStep) {
      store.dispatch(SET_ADVANCE_SUB_ACTIVE, {
        key: "secondStepActive",
        step: nextStep,
      });
    },

    save() {
      let errorMessage = this.validateForm(this.form);

      if (errorMessage) {
        return (this.errorMessage = errorMessage);
      }

      store.dispatch(ACCEPT_POLICY, {
        "systemCode": "SECWEBSITE",
        "subSystemCode": "RETIRECHKUP",
        "taskId": "-",
        "identityText": this.form.email,
        "identityType": "email",
        "authCompIdReference": "000000000000000",
        "fullName": this.form.email,
        "updatedBy": this.form.email,
        "userType": "Sender",
        "status": "accept"
      })

      // send email
      store
        .dispatch(SEND_EMAIL, { email: this.form.email, type: "advance" })
        .then((response) => {
          if (response.status === "yes") {
            // set alert
            store.dispatch(SET_ALERT, {
              email: this.form.email,
              range: this.form.period,
            });

            // show dialog message
            this.dialog.message = `<div class="text-center">
           <div class="md-title mb-3">ส่ง Email สำเร็จ</div>
           </div>
          `;

            this.redirect = true;
          } else {
            this.dialog.message = `<div class="text-center">
           <div class="md-title mb-3">ส่ง Email ไม่สำเร็จ <br>
           กรุณาลองใหม่อีกครั้ง
           </div>
           </div>
          `;
          }
          this.showDialogNormal = true;
          this.errorMessage = {};
        });
    },

    validateForm(data) {
      let validateRule = {
        email: {
          presence: {
            allowEmpty: false,
            message: "^โปรดระบุ: อีเมล",
          },
          email: {
            message: "^อีเมล ไม่ถูกต้อง",
          },
        },
      };

      // set data to validate
      let errMessageList = validate(
        {
          email: data.email,
        },
        validateRule
      );

      if (errMessageList) {
        const error = {};
        for (const [key, value] of Object.entries(errMessageList)) {
          let message = value[0];
          error[key] = message;
        }
        return error;
      } else {
        return false;
      }
    },

    close() {
      this.showDialogNormal = false;
      this.showDialogPolicy = false;

      if (this.redirect) {
        location.reload();
      }
    },

    changePlan(type, data) {
      data.changed.map((change) => {
        this.params[change.name] = change.value;
      });

      let objSuggestion = this.params;
      objSuggestion.suggestType = type;
      objSuggestion.suggestValue = data.value_raw;

      retirementService.calculateAdvance(objSuggestion).then((response) => {
        store.dispatch(SET_ADVANCE_STEPPER_DATA, {
          key: "result",
          data: response,
        });
      });

      const ScrollTo = scroller();
      ScrollTo(".md-card-header");
    },

    getInfo(type) {
      let data = assetsService.getAssetsInfo(type);
      if (!data) return;

      this.showDialogNormal = true;
      this.dialog.message = `<div class="text-center md-display-1 mb-2 txt-gray"> ${
        data.name
      } </div>
                                 <div class="md-title mb-3 txt-gray"> ${
                                   data.desc
                                 }
                                 </div>
                              `;
    },

    redirectType(type) {
      switch (type) {
        case "new":
          this.$router.push("/advance");
          location.reload();
          break;
        case "edit":
          this.$router.push(`/advance?uid=${localStorage.getItem("token")}`);
          location.reload();
          break;
      }
    },

    getPolicy() {
      this.showDialogPolicy = true;
      this.dialog.message = `<div class="text-center md-display-1 mb-2 txt-gray"> ${this.policy.policyContent.areaDecs} </div>
                                 <div class="md-title mb-3 txt-gray">${this.policy.policyContent.htmlContentText}</div>`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors";

.guidePlan {
  padding: 15px;
  background-color: $smoke;
  border-radius: 8px;
  margin-bottom: 30px;
  border: 2px solid $navy;
}

.title {
  font-size: 22px;
  margin-bottom: 15px;
  line-height: 1.1;
  text-align: center;
}

.button-gray {
  margin-bottom: 15px;
}

.line {
  max-width: 100px;
  background-color: $navy;
}

.content {
  height: 200px;
}

.stepper-content,
.result {
  font-size: 22px;
}

.img-flag {
  max-height: 150px;
}

@media only screen and (min-width: 768px) {
  .stepper-content {
    padding-right: 80px;
    padding-left: 80px;
  }
}

@media only screen and (max-width: 576px) {
  .img-flag {
    max-height: 80px;
  }
}
.img-result {
  max-width: 800px;
}
.person {
  width: 70px;
  z-index: 1;
  position: absolute;
  top: -30px;
}
button {
  color: #003865;
  display: inline-block;
  min-width: 100px;
  border-radius: 20px;
  cursor: pointer;
  text-align: center;
  padding: 8px 16px;
  background-color: #fbc248;
  filter: drop-shadow(1px 1px 3px rgba(0, 0, 0, 0.5));
  border-color: transparent;
  font-weight: bold;
}
button:disabled,
button[disabled] {
  background-color: #cccccc;
  color: #666666;
  display: inline-block;
  min-width: 100px;
  border-radius: 20px;
  cursor: pointer;
  text-align: center;
  padding: 8px 16px;
  filter: drop-shadow(1px 1px 3px rgba(0, 0, 0, 0.5));
  border-color: transparent;
  font-weight: bold;
}

a:hover, a:visited, a:link, a:active
{
    text-decoration: none;
    color: #003865;
}
.md-theme-default a:not(.md-button) {
  color: #003865;
  padding-left: 8px;
  text-decoration: none;
}
.md-theme-default a:hover(.md-button) {
  color: #003865;
  padding-left: 8px;
  text-decoration: none;
}
</style>
